import { constants as c, reducer } from './data'
import { saveSettings, saveUiSettings, setServers } from './actions'
import {
    getLanguage,
    getTestServers,
    getLauncherType,
    getAutoLaunchOnLogin,
    getAutoLaunchOnStartup,
    getLayout,
    getLaunchDelay,
} from './selectors'

export { default as middleware } from './middleware'

export const settingsReducer = reducer

// Constants are exposed as a way for settings to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    UI_SETTINGS_CHANGED: c.UI_SETTINGS_CHANGED, // LocalForageMiddleware
    BACKEND_SETTINGS_CHANGED: c.BACKEND_SETTINGS_CHANGED, // LauncherCommandMiddleware
    LANGUAGE_CHANGED: c.LANGUAGE_CHANGED, // LanguageMiddleware
    FORGET_ALL_USERS: c.FORGET_ALL, // LogoutMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    saveSettings, // SettingManager
    saveUiSettings, // localforage
    setServers, // ServerMiddleware
}

// Selectors are a way to expose the internal state of this feature to those
// who are interested
export const selectors = {
    getLanguage,
    getTestServers,
    getLauncherType,
    getAutoLaunchOnLogin,
    getAutoLaunchOnStartup,
    getLayout,
    getLaunchDelay,
}



// WEBPACK FOOTER //
// ./src/features/Settings/exports.js